/**
 * @fileoverview NoteRenderer component for the Storyteller web application.
 * Renders a note/instruction element with translation support.
 *
 * @example
 * // Basic usage
 * <NoteRenderer
 *   text="instructions.welcome"
 *   uischema={{
 *     options: {
 *       emphasis: true,
 *       icon: "info"
 *     }
 *   }}
 * />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { useTranslation } from 'react-i18next'
import { Instructions } from '../../sections/Instructions'

/**
 * @function Note
 * @description Component for rendering a note form element.
 * @param {LabelProps} props - The props for the Note component.
 * @returns {JSX.Element} The Note component.
 */
function Note(props: LabelProps) {
    const { t } = useTranslation()
    const { text, uischema } = props
    return <Instructions options={uischema.options} instructions={t(text)} />
}

export const NoteTester = rankWith(3, uiTypeIs('Note'))

export default withVanillaControlProps(withJsonFormsLabelProps(Note))
